import { gql } from '@apollo/client';

export const ADD_BRAND_RESTRICTED_CATEGORY = gql`
  mutation AddBrandRestrictedCategory(
    $input: AddBrandRestrictedCategoryInput!
  ) {
    addBrandRestrictedCategory(input: $input) {
      id
      name
      usedByBrandsCount
      usedByTalentsCount
    }
  }
`;

export const UPDATE_BRAND_RESTRICTED_CATEGORY = gql`
  mutation UpdateBrandRestrictedCategory(
    $input: UpdateBrandRestrictedCategoryInput!
  ) {
    updateBrandRestrictedCategory(input: $input) {
      id
      name
      usedByBrandsCount
      usedByTalentsCount
    }
  }
`;

export const DELETE_BRAND_RESTRICTED_CATEGORY = gql`
  mutation DeleteBrandRestrictedCategory(
    $input: DeleteBrandRestrictedCategoryInput!
  ) {
    deleteBrandRestrictedCategory(input: $input) {
      id
      name
      usedByBrandsCount
      usedByTalentsCount
    }
  }
`;
